export default "__VITE_ASSET__DhE5$$8L__"